const initialState = {
    open: false,
  };
  
  const SetOpen = "SetOpen";
  
  export const setOpen = (value) => ({
    type: SetOpen,
    payload: value,
  });
  
  const ModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case SetOpen:
        return { ...state, open: action.payload };
      default:
        return state;
    }
  };
  
  export default ModalReducer;
  